const getItem = (key) => {
  return window.localStorage.getItem(key)
}

function setItem(key, value) {
  return window.localStorage.setItem(key, value)
}

function removeItem(key) {
  return window.localStorage.removeItem(key)
}

const removeAll = () => {
  return window.localStorage.clear()
}

export default {
  getItem, setItem, removeItem, removeAll
}


// WEBPACK FOOTER //
// ./src/utils/localStorage.js